import * as actionTypes from '../actions/actionTypes';

const intiData = {
  data: {
    accountSignatories: [],
    eChannelReporting: []
  },
  echannels: [],
  statuses: {
    basicDetails: {
      status: "incomplete"
    },
    addressAndContact: {
      status: "incomplete"
    },
    accountSignatories: {
      status: "incomplete"
    },
    paperStatement: {
      status: "incomplete"
    },
    eChannelReporting: {
      status: "incomplete"
    }
  }
};

export default function currentProductAccountReducer(state = intiData, action) {
  switch(action.type){
    case actionTypes.SET_CURRENT_PRODUCT_ACCOUNT: {
      let newState = {...state};
      newState.data = action.productAccountData;
      return newState;
    }
    case actionTypes.RESET_CURRENT_PRODUCT_ACCOUNT : {
      return intiData;
    }
    case actionTypes.SET_CURRENT_PRODUCT_ACCOUNT_ECHANNELS: {
      let newState = {...state};
      newState.echannels = action.echannels;
      return newState;
    }
    case actionTypes.SET_CURRENT_PRODUCT_ACCOUNT_STATUSES: {
      let newState = {...state};
      newState.statuses = action.statuses;
      return newState;
    }
    case actionTypes.SET_NEW_ACCOUNT_ACTIVE_TAB_INDEX: {
      let newState = {...state};
      newState.activeTabIndex = action.index;
      return newState;
    }
    case actionTypes.RESET_NEW_ACCOUNT_ACTIVE_TAB_INDEX: {
      let newState = {...state};
      newState.activeTabIndex = 0;
      return newState;
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/reducers/currentProductAccountReducer.js